// อวาตาร์ตัวละครสร้างในเครื่องด้วย DiceBear (สไตล์ Lorelei — CC0, ใช้เชิงพาณิชย์ได้) ไม่ยิงเว็บภายนอก
// import เฉพาะสไตล์เดียว (collection เป็น ESM sideEffects:false จึง tree-shake ได้)
import { createAvatar } from "@dicebear/core";
import * as lorelei from "@dicebear/lorelei";

// สไตล์ต้นฉบับเป็นขาว-ดำ — ใส่พาเลตต์สีเข้าธีม (ผมม่วง/ชมพู/ทอง ฯลฯ) ให้ดูสดใสน่ารัก
const LOOK = {
  skinColor: ["ffe3d1", "fdd5bb", "f7c6a3", "ebae85", "d99a70"],
  hairColor: ["3b2457", "7c3aed", "ec4899", "a855f7", "6b3f23", "f5b942", "1f2937", "3b82f6", "f472b6"],
  mouthColor: ["d9546b", "e8677d"],
  earringsColor: ["fbbf24"],
  hairAccessoriesColor: ["ec4899", "fbbf24", "a78bfa", "34d399"],
  glassesColor: ["1f2937", "7c3aed"],
  frecklesColor: ["d99a70"],
};

const cache = new Map();

/** data URI (SVG) ของอวาตาร์จาก seed — seed เดิม = หน้าตาเดิมเสมอ */
export function avatarUri(seed) {
  const key = String(seed ?? "") || "?";
  let uri = cache.get(key);
  if (!uri) {
    uri = createAvatar(lorelei, { seed: key, radius: 0, ...LOOK }).toDataUri();
    if (cache.size > 300) cache.clear();
    cache.set(key, uri);
  }
  return uri;
}
